import { defineFcm } from '../shared/factory';

export const FCM_CREAM_CHIP_IN_VALUES = defineFcm('cream_chip_in_values').asNumber().withDefault(undefined).toConfig({
	owner: 'TBD',
	scope: 'corgi-front-end',
	context: 'PSF promote or share page',
	description:
		'Defines which amount to set in the "chip in" button. Should be in the country\'s currency (e.g. "5" for "5 euros")',
	import: false,
	deprecated:
		'Front-end usage removed — combo page chip-in amount now defaults to the country promotion settings minimum amount; safe to delete after 2026-09-03',
});
